import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import moment from "moment";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helperTime from "../../../../helpers/time";
import statusDiscount from "./status-discount";
import typeAmountDiscount from "./type-amount";

function ViewDiscountCampaignBanner() {
  const initDiscount = {
    title: "",
    amount: "",
    count_use: "",
    conditions: {
      max_count_use_discount: 0,
      max_count_use_each_user: 0,
      min_count_days_category_user_site_publisher: 0,
      min_price_category_user_site_publisher: 0,
      rate_start_date_category_user_site_publisher: 0,
      rate_end_date_category_user_site_publisher: 0,
      start_date_discount: 0,
      end_date_discount: 0,
      users_which_can_use_discount: [],
    },
    type: "",
    type_amount: "",
    created_at: "",
  };
  const [discount, setDiscount] = useState(initDiscount);
  const [usersIDS, setUsersIDS] = useState([]);
  const [users, setUsers] = useState([]);
  const history = useHistory();
  const params = useParams();
  const discountID = params.id;

  useEffect(() => {
    getDiscount(discountID);
  }, []);

  const getDiscount = async (discountID) => {
    const discount = await sendRequestGetDiscount(discountID);
    if (!discount) {
      return;
    }
    setDiscount(discount);
    setUsersIDS(discount.conditions.users_which_can_use_discount);
  };

  useEffect(() => {
    if (usersIDS.length == 0) {
      return;
    }
    setUsersInState();
  }, [usersIDS]);

  const setUsersInState = async () => {
    let users = [];
    for (let usersIDSKey in usersIDS) {
      let userID = usersIDS[usersIDSKey];
      users.push(await getUser(userID));
    }
    setUsers(users);
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetDiscount = async (discountID) => {
    let result;
    let headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/discount/manage/banner/" +
          discountID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }

    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return result.data.data;
  };

  const generateStatusTagDiscount = (status) => {
    status = +status;
    return (
      <>
        <span
          className={`badge  ${
            status === statusDiscount.typeGroupPublisher.DISABLE
              ? "badge-danger"
              : ""
          }  ${
            status === statusDiscount.typeGroupPublisher.ENABLE
              ? "badge-success"
              : ""
          } 
            `}
        >
          {statusDiscount.getTypeGroupPublisherPersianName()[status]}
        </span>
      </>
    );
  };

  const getUser = async (userID) => {
    const user = await sendRequestGetUser(userID);
    if (!user) {
      return;
    }

    return user;
  };

  const sendRequestGetUser = async (userID) => {
    let result;
    let headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/info-user/" + userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }

    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return result.data.data;
  };

  const generateUsersWhichCanUseDiscount = () => {
    if (users.length === 0) {
      return "همه کاربران";
    }

    return users.map((user) => {
      return (
        <>
          <li>شماره کاربری : ‌{user.user_id}</li>
          <li>نام کاربر : {user.firstname}</li>
          <li> نام خانوادگی کاربر : ‌{user.lastname}</li>
          <hr className="bg-white" />
        </>
      );
    });
  };

  const generateDiscount = () => {
    if (!discount) {
      return;
    }

    return (
      <div className="table-responsive">
        <table className="table table-bordered table-dark tbl-td-white-space table-hover m-0">
          <tbody>
            <tr>
              <td>عنوان</td>
              <td>{discount.title}</td>
            </tr>

            <tr>
              <td>مقدار</td>
              <td>
                <span className="number-finance">
                  {typeAmountDiscount.typeAmountValue[discount.type_amount] ==
                  typeAmountDiscount.typeAmountString.PRICE
                    ? helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(discount.amount)
                      )
                    : ""}
                  {typeAmountDiscount.typeAmountValue[discount.type_amount] ==
                  typeAmountDiscount.typeAmountString.PERCENT
                    ? helperNumbers.toPersianNum(discount.amount)
                    : ""}
                </span>

                <span className="pr-1">
                  {typeAmountDiscount.typeAmountValue[discount.type_amount] ==
                  typeAmountDiscount.typeAmountString.PRICE
                    ? "تومان"
                    : ""}
                  {typeAmountDiscount.typeAmountValue[discount.type_amount] ==
                  typeAmountDiscount.typeAmountString.PERCENT
                    ? "درصد"
                    : ""}
                </span>
              </td>
            </tr>

            <tr>
              <td>وضعیت</td>
              <td>{generateStatusTagDiscount(discount.active)}</td>
            </tr>

            <tr>
              <td>تعداد استفاده از کد تخفیف</td>
              <td>{helperNumbers.toPersianNum(discount.count_use)}</td>
            </tr>

            <tr>
              <td>شرط حداقل مبلغ گروه نمایش دهنده برای تخفیف</td>
              <td>
                <span className="number-finance pl-2">
                  {discount.conditions.min_price_category_user_site_publisher ==
                  "0"
                    ? "بدون محدودیت"
                    : helperNumbers.toPersianNum(
                        discount.conditions
                          .min_price_category_user_site_publisher
                      ) + " تومان"}
                </span>
              </td>
            </tr>

            <tr>
              <td>شرط حداقل تعداد روز نمایش</td>
              <td>
                {discount.conditions
                  .min_count_days_category_user_site_publisher == "0"
                  ? "بدون محدودیت"
                  : helperNumbers.toPersianNum(
                      discount.conditions
                        .min_count_days_category_user_site_publisher
                    )}
              </td>
            </tr>

            <tr>
              <td>شرط تاریخ و ساعت شروع استفاده از کد تخفیف</td>
              <td dir="ltr" className="number-finance pl-2">
                {discount.conditions.start_date_discount == "0"
                  ? "بدون محدودیت"
                  : helperNumbers.toPersianNum(
                      helperTime.convertGregorianToJalali(
                        discount.conditions.start_date_discount
                      ) +
                        " " +
                        discount.conditions.start_date_discount.split("_")[1]
                    )}
              </td>
            </tr>

            <tr>
              <td>شرط تاریخ و ساعت پایان استفاده از کد تخفیف</td>
              <td dir="ltr" className="number-finance pl-2">
                {discount.conditions.end_date_discount == "0"
                  ? "بدون محدودیت"
                  : helperNumbers.toPersianNum(
                      helperTime.convertGregorianToJalali(
                        discount.conditions.end_date_discount
                      ) +
                        " " +
                        discount.conditions.end_date_discount.split("_")[1]
                    )}
              </td>
            </tr>

            <tr>
              <td>شرط بازه تاریخ شروع گروه نمایش دهنده</td>
              <td dir="rtl" className="number-finance pl-2">
                {discount.conditions
                  .rate_start_date_category_user_site_publisher == "0" ? (
                  "بدون محدودیت"
                ) : (
                  <div className="d-flex text-right">
                    <span>
                      {helperNumbers.toPersianNum(
                        helperTime.convertGregorianToJalali(
                          discount.conditions.rate_start_date_category_user_site_publisher.split(
                            "_"
                          )[0]
                        )
                      )}
                    </span>
                    <span className="px-2">تا</span>
                    <span>
                      {helperNumbers.toPersianNum(
                        helperTime.convertGregorianToJalali(
                          discount.conditions.rate_start_date_category_user_site_publisher.split(
                            "_"
                          )[1]
                        )
                      )}
                    </span>
                  </div>
                )}
              </td>
            </tr>

            <tr>
              <td>شرط بازه تاریخ پایان گروه نمایش دهنده</td>
              <td dir="rtl" className="number-finance pl-2">
                {discount.conditions
                  .rate_start_date_category_user_site_publisher == "0" ? (
                  "بدون محدودیت"
                ) : (
                  <div className="d-flex">
                    <span>
                      {helperNumbers.toPersianNum(
                        helperTime.convertGregorianToJalali(
                          discount.conditions.rate_end_date_category_user_site_publisher.split(
                            "_"
                          )[0]
                        )
                      )}
                    </span>
                    <span className="px-2">تا</span>
                    <span>
                      {helperNumbers.toPersianNum(
                        helperTime.convertGregorianToJalali(
                          discount.conditions.rate_end_date_category_user_site_publisher.split(
                            "_"
                          )[1]
                        )
                      )}
                    </span>
                  </div>
                )}
              </td>
            </tr>

            <tr>
              <td>شرط محدودیت بیشترین استفاده کد تخفیف</td>
              <td>
                {discount.conditions.max_count_use_discount == "0"
                  ? "بدون محدودیت"
                  : helperNumbers.toPersianNum(
                      discount.conditions.max_count_use_discount
                    )}
              </td>
            </tr>

            <tr>
              <td>شرط محدودیت بیشترین استفاده کد تخفیف هر کاربر</td>
              <td>
                {discount.conditions.max_count_use_discount == "0"
                  ? "بدون محدودیت"
                  : helperNumbers.toPersianNum(
                      discount.conditions.max_count_use_each_user
                    )}
              </td>
            </tr>

            <tr>
              <td>استفاده کاربران از کد تخفیف :</td>
              <td>
                <ul className="list-unstyled">
                  {generateUsersWhichCanUseDiscount()}
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">نمایش اطلاعات کد تخفیف</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">{generateDiscount()}</div>
          </div>
        </section>
      </div>
    </>
  );
}
export default ViewDiscountCampaignBanner;
